export default "__VITE_ASSET__ffb8811b__"